import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  jobAudits: [],

  errors: null,
  loader: null,
  success: false,
};

export default function audits(state = initialState, action) {
  switch (action.type) {
    

    case ACTIONS_TYPES.GET_JOB_AUDITS_REQUEST:
      return { ...state, loader: true, errors: null};

    case ACTIONS_TYPES.GET_JOB_AUDITS_SUCCESS:
      return { ...state, jobAudits: action.payload, loader: false, success: true };

    case ACTIONS_TYPES.GET_JOB_AUDITS_FAILED:
      return { ...state, loader: false, errors: action.payload };

    default:
      return state;
  }
}